import { FlexContainer } from '@taxdown/piccolo-web';
import styled, { css } from 'styled-components';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Container = styled(FlexContainer)`
  padding: ${({ theme: { sizing } }) => ` ${sizing.fds_size_16} 0`};
  max-width: 300px;
`;

export const ModalContainer = styled(FlexContainer)`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 99;
  background: ${({ theme: { colors } }) => colors.darken};
`;

export const ModalContent = styled(FlexContainer)`
  position: relative;
  background-color: ${({ theme: { colors } }) => colors.white};
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_M};
  width: ${({ width }) => css`
    ${width}
  `};
  padding: ${({ theme: { sizing } }) => sizing.fds_size_16};
  max-height: 650px;
  overflow: scroll;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    min-width: 90%;
    max-width: 90%;
  }
`;

export const CloseButton = styled.button`
  cursor: pointer;

  svg {
    width: ${({ theme: { sizing } }) => sizing.fds_size_16};
    height: ${({ theme: { sizing } }) => sizing.fds_size_16};
  }
`;
